import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService, FoodKind } from '@app/shared';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductGuard implements CanActivate {

  constructor(protected api: ApiService, protected router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const path = route.routeConfig.path;

    if (path !== '') {
      return true;
    }

    return this.api.getYearId()
      .pipe(
        switchMap(yearId =>
          this.api.foodFindFood({
            yearId,
            kind: FoodKind.Product,
            limit: 1,
          })
        ),
        map(rv => {
          if (rv.foods.length > 0) {
            return this.router.createUrlTree(['products', rv.foods[0].id]);
          }
          return this.router.createUrlTree(['products', 'new']);
        })
      );
  }

}
